<div class="header" #headerElement>
  <h1 *ngIf="userSettingsService.serviceType === 'ic'">Invoice Capture Applications</h1>
  <h1 *ngIf="userSettingsService.serviceType === 'dc'">Document Capture Applications</h1>
  <div class="buttons">
    <add-button class="create-application" [ngClass]="{'create-application--disabled': !canCreateApplication()}"
      (click)="createApplication()">
    </add-button>
    <filter [filter]="filter" (applied)="applyFilter($event)"></filter>
  </div>
</div>
<div class="text">
  Applications in the FlexiCapture Cloud define the settings which will be used for the uploaded documents processing.
  They can determine document types, list of fields to be exrtracted, rules to be checked and more. You can use REST API
  to create a processing task and send it to be processed with any of your applications. To create and start the task,
  you need to know the application credentials which are Application ID and Token. This page contains both credentials
  for each of your applications and tools to manage the applications.
</div>
<div class="sort" [ngClass]="{'sort--disabled': isSortDisabled()}">
  <div>Sort by:</div>
  <div class="sort-name" [ngClass]="{'sort-active': sortName === 'id'}" (click)="sort('id')">
    <span>Date</span>
    <svg-icon class="sort-icon" src="/assets/icons/sort.svg"
      [ngClass]="{'sort-icon-hidden': sortName !== 'id', 'sort-icon-forward': !sortBackward}">
    </svg-icon>
  </div>
  <div class="sort-name" [ngClass]="{'sort-active': sortName === 'name'}" (click)="sort('name')">
    <span>Name</span>
    <svg-icon class="sort-icon" src="/assets/icons/sort.svg"
      [ngClass]="{'sort-icon-hidden': sortName !== 'name', 'sort-icon-forward': !sortBackward}">
    </svg-icon>
  </div>

</div>
<header (sorted)="sort($event)" [sortBackward]="sortBackward" [columnName]="sortName"
  [showActiveApp]="showControlsForCustomApps()"></header>
<application *ngFor="let application of applications; trackBy: trackByFn" [application]="application"
  [serviceType]="userSettingsService.serviceType" [showActiveApp]="showControlsForCustomApps()"
  [applicationsCount]="applicationsCount"></application>
<footer class="footer" *ngIf="showFooter()">
  <pagination class="ui-table-row" [count]="count" [page]="page" (pageChange)="onPageChange($event)" [step]="batchSize">
  </pagination>
</footer>
